import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles(() => ({
  bar: {
    background: 'linear-gradient(90deg, #4DABF7, #CC5DE8)'
  }
}));
